import 'react-tabs/style/react-tabs.css'

import { useBookingsContext } from "../hooks/useBookingsContext"
import BookingDetails from '../components/BookingDetails'

import { strings } from '../strings'
import '../styling/bookingDetails.css'

const MyBookings = () => {

    const { bookings } = useBookingsContext()
    
    return (
        <div className='myBookingsContainer'>
            {(bookings && bookings.length > 0) ? bookings.map((booking) => <BookingDetails key={booking._id} booking={booking}/>) : <div className='no-bookings'>{strings.myBookings.noBookings}</div>}
        </div>
    )
}

export default MyBookings
